

function LeadershipTier12DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                Your tactical commands have all been empowered to do more in the same amount of time.
                <br />
                This also allows Charisma to be a damage-dealing attribute for your character when used with
                Knight Takes Pawn or Promotion, in addition to its other myriad of benefits.
            </div>
            <p>
                <b className="AbilityHeaderSmall">THEMING</b>
                <div className="animationFadeIn">
                    This Talent represents your seasoned experience when dealing with combat sorties.
                    <br />
                    You've become quite the commander by this point and it shows by the way you command your team.
                </div>
            </p>
            <br />
        </div>
    )
}

export { LeadershipTier12DesignTemplate };